__turbopack_context__.v({
  "cardTitle": "Home-module__ErwY6W__cardTitle",
  "cta": "Home-module__ErwY6W__cta",
  "ctaTitle": "Home-module__ErwY6W__ctaTitle",
  "displayText": "Home-module__ErwY6W__displayText",
  "gradient-move": "Home-module__ErwY6W__gradient-move",
  "gradientText": "Home-module__ErwY6W__gradientText",
  "hero": "Home-module__ErwY6W__hero",
  "heroCtaLink": "Home-module__ErwY6W__heroCtaLink",
  "heroCtas": "Home-module__ErwY6W__heroCtas",
  "heroGradient": "Home-module__ErwY6W__heroGradient",
  "heroHighlights": "Home-module__ErwY6W__heroHighlights",
  "heroHighlightsGrid": "Home-module__ErwY6W__heroHighlightsGrid",
  "heroSubtext": "Home-module__ErwY6W__heroSubtext",
  "heroTitle": "Home-module__ErwY6W__heroTitle",
  "heroTitleWrapper": "Home-module__ErwY6W__heroTitleWrapper",
  "home": "Home-module__ErwY6W__home",
  "lead": "Home-module__ErwY6W__lead",
  "sectionAccentCyan": "Home-module__ErwY6W__sectionAccentCyan",
  "sectionAccentPink": "Home-module__ErwY6W__sectionAccentPink",
  "sectionAccentPurple": "Home-module__ErwY6W__sectionAccentPurple",
  "sectionAccentTeal": "Home-module__ErwY6W__sectionAccentTeal",
  "sectionAccentViolet": "Home-module__ErwY6W__sectionAccentViolet",
  "sectionAccentYellow": "Home-module__ErwY6W__sectionAccentYellow",
  "sectionTitle": "Home-module__ErwY6W__sectionTitle",
  "selectedClientsDivider": "Home-module__ErwY6W__selectedClientsDivider",
  "selectedClientsLabel": "Home-module__ErwY6W__selectedClientsLabel",
  "workImage": "Home-module__ErwY6W__workImage",
  "workItem": "Home-module__ErwY6W__workItem",
});
